module.exports = __webpack_public_path__ + "static/media/ownerAgreement2.2d01b0c2.png";